import { atom } from 'recoil';

const defaultLocale = navigator.language.split(/[-_]/)[0] ?? 'en';

export const localeState = atom<string>({
    key: 'localeState',
    default: defaultLocale,
});
